import { storageService } from "src/services/api";

const state = {
  status: {},
  errors: [],
  statusText: "",
  data: [],
  metaData: {},
  path: [],
  dataParam: {
    status: "",
    keyword: "",
    page: "",
    tags: [],
    limit: 50,
  },
  single: {},

  tableFilter: {
    SearchTerm: null,
    clientId: null,
    tags: null,
    isTimeClockRunning: null,
    hideCompleted: null,
    status: null,
  },
  loadingTable: false,
};

const defaultFilter = {
  SearchTerm: null,
  clientId: null,
  tags: null,
  isTimeClockRunning: null,
  hideCompleted: null,
  status: null,
};

const actions = {
  async applyTableFilter({ commit, dispatch }, params) {
    commit("setTableFilter", {
      ...defaultFilter,
      ...params,
    });
    dispatch("getFolder", params);
  },

  async clearTableFilter({ commit }) {
    commit("setTableFilter", {
      SearchTerm: null,
      clientId: null,
      dateStart: null,
      dateEnd: null,
      status: null,
    });
  },

  async clearData({ commit }) {
    commit("setData", []);
  },

  async clearFilter({ commit }) {
    commit("setFilter", {
      keyword: "",
      page: "",
      limit: 50,
    });
  },

  async getAll({ commit, dispatch }, params = {}) {
    commit("setLoadingTable", true);
    await storageService.getAll(params).then(
      (response) => {
        commit("setData", response.data);
        commit("setMetaData", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
        commit("setLoadingTable", false);
      }
    );
  },

  async getFolder({ commit, dispatch }, params = {}) {
    commit("setLoadingTable", true);
    await storageService.getFolder(params).then(
      (response) => {
        const { files, folders, path } = response;
        const filteredFiles = files.map((item) => {
          return { ...item, isFolder: false, icon: "description" };
        });
        const filteredFolders = folders.map((item) => {
          return {
            ...item,
            isFolder: true,
            icon: "mdi-folder",
            parentId: item.parentId ? item.parentId : "",
          };
        });
        const sortedPath = [{"id": 0, "name": "Home", "depth": 0}, ...path]
          .sort((a, b) => a.depth > b.depth);
        commit("setData", [...filteredFolders, ...filteredFiles]);
        commit("setPath", sortedPath);
        commit("setMetaData", response.metaData);
        commit("setLoadingTable", false);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
        commit("setLoadingTable", false);
      }
    );
  },

  async search({ commit }, params = { keyword: "", page: "", limit: 50 }) {
    commit("setFilter", params);
  },

  async create({ commit, dispatch }, payload) {
    await storageService.create(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Create successfull",
        };
        commit("setSingle", response);
        commit("createSuccess", formattedResponse);
        dispatch("snackbar/success", `Add file "${response.name}" successful`, {
          root: true,
        });
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async upload({ commit, dispatch }, payload) {
    await storageService.upload(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Create successfull",
        };
        commit("setSingle", response);
        commit("createSuccess", formattedResponse);
        dispatch(
          "snackbar/success",
          `Upload new file "${response.name}" successful`,
          {
            root: true,
          }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async download({ commit, dispatch }, payload) {
    try {
      commit("setSingle", "test");
      let response = await storageService.download(payload);
      if (response.ok) {
        let text = await response.blob();
        let url = URL.createObjectURL(new Blob([text], { type: payload.type }));
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", payload.name);
        link.click();
      } else {
        dispatch("snackbar/error", `Downloading file ${payload.name} error`, {
          root: true,
        });
      }
    } catch (responseError) {
      dispatch("snackbar/error", `Downloading file ${payload.name} error`, {
        root: true,
      });
    }
  },

  async update({ commit, dispatch }, payload) {
    await storageService.update(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Update successfull",
        };

        commit("updateSuccess", formattedResponse);
        commit("updateData", formattedResponse.data);
        dispatch(
          "snackbar/success",
          `Update file "${payload.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async updateStatus({ commit, dispatch }, payload) {
    await storageService.updateStatus(payload).then(
      (response) => {
        let formattedResponse = {
          data: response,
          message: "Update successfull",
        };

        commit("updateSuccess", formattedResponse);
        commit("updateData", formattedResponse.data);
        dispatch(
          "snackbar/success",
          `Update file "${response.name}" successful`,
          { root: true }
        );
      },
      (responseError) => {
        commit("createFailure", responseError);
        dispatch("alert/error", responseError, { root: true });
      }
    );
  },

  async delete({ commit, dispatch }, payload) {
    await storageService.delete(payload).then(
      (response) => {
        commit("deleteSuccess", response);
        // commit("deleteData", response.data);
        dispatch(
          "snackbar/success",
          `Delete file "${payload.name}" successful`,
          { root: true }
        );
      },
      () => {
        dispatch("snackbar/error", `Delete file "${payload.name}" error`, {
          root: true,
        });
      }
    );
  },

  async getById({ commit }, id) {
    await storageService.getById(id).then(
      (response) => {
        commit("setSingle", response);
        // dispatch(
        //   "snackbar/success",
        //   `Add user group "${payload.name}" successful`,
        //   { root: true }
        // );
      },
      (responseError) => {
        commit("createFailure", responseError);
        // dispatch("alert/error", responseError, { root: true });
      }
    );
  },
};

const mutations = {
  setLoadingTable(state, data) {
    state.loadingTable = data;
  },

  setTableFilter(state, data) {
    state.tableFilter = data;
  },

  setData(state, data) {
    state.data = data;
  },

  setMetaData(state, data) {
    state.metaData = data;
  },

  setPath(state, data) {
    state.path = data;
  },

  setFilter(state, param) {
    state.dataParam = param;
  },

  setSingle(state, data) {
    state.single = data;
  },

  appendData(state, item) {
    state.data.push(item);
  },

  updateData(state, item) {
    const index = state.data.findIndex((data) => data.id === item.id);
    if (index !== -1) state.data.splice(index, 1, item);
  },

  deleteData(state, item) {
    state.data.splice(state.data.indexOf(item.id), 1);
  },

  createSuccess(state, response) {
    state.statusText = "create-ok";
    state.status = {
      error: false,
      message: response.message,
    };
    state.single = response.data;
  },

  deleteSuccess(state, response) {
    state.statusText = "delete-ok";
    state.status = { error: false, message: response.message };
  },

  updateSuccess(state, response) {
    state.statusText = "update-ok";
    state.status = { error: false, message: response.message };
  },

  createFailure(state, response) {
    state.statusText = "create-error";
    state.status = { error: true, message: response.message };
  },
};

function checkAccess(file, rootState, userActionId) {
  let currentUserGroupId = rootState["account"].data.permissions.id;
  let isAdmin = rootState["account"].data.isAdmin;
  let myPerms = file.permissions;
  let hasAccess = myPerms.filter(
    (p) =>
      p.userGroupId == currentUserGroupId &&
      (p.access == true) & (p.userActionId == userActionId)
  );
  return hasAccess.length > 0 || isAdmin;
}

const getters = {
  getMetaData(state) {
    return state.metaData;
  },
  
  getAll(state, current, rootState) {
    current;
    let data = state.data;

    let filteredData = data.filter((file) => {
      return checkAccess(file, rootState, 1);
    });

    const output = filteredData.map((fileOrFolder) => {
      return {
        ...fileOrFolder,
        canDownload: checkAccess(fileOrFolder, rootState, 1), // view
        canEdit: checkAccess(fileOrFolder, rootState, 3), //edit
        canDelete: checkAccess(fileOrFolder, rootState, 4), //delete
      };
    });
    return output;
  },
  getType: (state) => (value) => {
    return state.typeOptions.find((type) => type.value == value);
  },
};

export const storage = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
